import React from 'react'
import MasterLayout from '../masterLayout/MasterLayout'
import  CampaignLayerList  from '../components/campaigns/CampaignLayerList'


export const CampaignListPage = () => {
  return (

    <MasterLayout>
        <CampaignLayerList/>
    </MasterLayout>
  
  )
}
